import { computed, ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-2b704a37"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "table-content"
};
const _hoisted_2 = {
  class: "btn-content flex-end"
};
const _hoisted_3 = {
  class: "btn-content"
};
const _hoisted_4 = {
  key: 0,
  class: "handle-content"
};
const _hoisted_5 = {
  key: 1,
  class: "num"
};
const _hoisted_6 = {
  key: 2
};
import { message, Modal } from 'ant-design-vue';
import { createVNode } from 'vue';
import { ExclamationCircleOutlined } from '@ant-design/icons-vue';
import { useStore } from '@/store';
import { postListInformationNotice, postGetBackInformationNotice, postDeleteInformationNotice } from '@/api/systemNotification';
import { OK, dateFormatNoTime } from '@/common';
import { statusList } from '@/common/dataJson/systemNotification';
// import  treePopover  from './treePopover.vue'
import dayjs from 'dayjs';
import { getOrgListFetch } from '@/api/userbook';
export default /*#__PURE__*/_defineComponent({
  __name: 'NotificaTableBlock',
  setup(__props, {
    expose
  }) {
    const userInfo = computed(() => useStore().userInfo && JSON.parse(useStore().userInfo));
    const router = useRouter();
    const columns = [{
      title: '序号',
      dataIndex: 'id',
      key: 'id',
      width: 60
    }, {
      title: '通知标题',
      dataIndex: 'title',
      key: 'title',
      ellipsis: true
    }, {
      title: '发送对象',
      dataIndex: 'sendUserNum',
      key: 'sendUserNum'
    }, {
      title: '发送状态',
      dataIndex: 'sendStatus',
      key: 'sendStatus'
    }, {
      title: '创建时间',
      dataIndex: 'createTimeStr',
      key: 'createTimeStr'
    }, {
      title: '发送时间',
      dataIndex: 'sendTimeStr',
      key: 'sendTimeStr'
    }, {
      title: '创建人',
      dataIndex: 'createUser',
      key: 'createUser'
    }, {
      title: '操作',
      dataIndex: 'handle',
      key: 'handle',
      align: 'right'
    }];
    const tableLoading = ref(false);
    const dataSource = ref([]); // 表格数据
    const selectedRowKeys = ref([]); // 选中的行
    const searchObj = ref({
      title: '',
      sendStatus: '',
      createTime: [],
      sendTime: []
    }); // 搜索条件
    const tableRef = ref(); // 表格ref
    const getTimeDate = times => {
      return times ? dayjs(times).format(dateFormatNoTime) : '';
    };
    const getData = async () => {
      var _searchObj$value$crea, _searchObj$value$crea2, _searchObj$value$send, _searchObj$value$send2;
      const params = {
        createEndDate: getTimeDate((_searchObj$value$crea = searchObj.value.createTime) === null || _searchObj$value$crea === void 0 ? void 0 : _searchObj$value$crea[1]),
        createStartDate: getTimeDate((_searchObj$value$crea2 = searchObj.value.createTime) === null || _searchObj$value$crea2 === void 0 ? void 0 : _searchObj$value$crea2[0]),
        sendEndDate: getTimeDate((_searchObj$value$send = searchObj.value.sendTime) === null || _searchObj$value$send === void 0 ? void 0 : _searchObj$value$send[1]),
        sendStartDate: getTimeDate((_searchObj$value$send2 = searchObj.value.sendTime) === null || _searchObj$value$send2 === void 0 ? void 0 : _searchObj$value$send2[0]),
        sendStatus: searchObj.value.sendStatus,
        title: searchObj.value.title
      };
      tableLoading.value = true;
      try {
        const {
          data,
          code
        } = await postListInformationNotice(params);
        if (code === OK) {
          if (data) {
            dataSource.value = data;
          }
        }
      } catch (e) {}
      tableLoading.value = false;
    }; // 获取表格数据
    const searchData = async obj => {
      searchObj.value = obj;
      await getData();
    }; // 搜索
    const onSelectChange = keys => {
      selectedRowKeys.value = keys;
    }; // 选中行
    const pushSystemNotificationDetail = obj => {
      router.push({
        name: 'systemNotificationDetail',
        query: {
          ...obj
        }
      });
    };
    const toAddNotification = () => {
      pushSystemNotificationDetail({
        type: 'add'
      });
    }; // 跳转发布通知页面
    const LookListItem = id => {
      pushSystemNotificationDetail({
        type: 'look',
        id: id
      });
    };
    const GoBackItem = id => {
      let params = {
        id: id,
        sendStatus: 2
      };
      Modal.confirm({
        title: '撤回系统通知',
        icon: createVNode(ExclamationCircleOutlined),
        content: '该操作会删除用户的通知记录，您可以在编辑后重新发送，确定取回吗？',
        okText: '确 定',
        okType: 'danger',
        cancelText: '取 消',
        onOk: async () => {
          try {
            const {
              msg,
              code
            } = await postGetBackInformationNotice(params);
            if (code === OK) {
              message.success(msg);
              getData();
            }
          } catch (e) {}
        },
        onCancel() {}
      });
    };
    // const EditListItem = (id:string)=>{
    //   pushSystemNotificationDetail({type:'edit',id:id})
    // }
    const DelListItem = async ids => {
      let params = {
        noticeIds: ids
      };
      Modal.confirm({
        title: '删除系统通知',
        icon: createVNode(ExclamationCircleOutlined),
        content: '该操作不可恢复，确定删除吗？',
        okText: '确 定',
        okType: 'danger',
        cancelText: '取 消',
        onOk: async () => {
          try {
            const {
              msg,
              code
            } = await postDeleteInformationNotice(params);
            if (code === OK) {
              message.success(msg);
              getData();
            }
          } catch (e) {}
        },
        onCancel() {}
      });
    };
    const batchDetel = () => {
      if (!selectedRowKeys.value.length) {
        return message.info('请选择');
      }
      const ids = selectedRowKeys.value.join(',');
      DelListItem(ids);
    };
    // 发送对象
    const treeData = ref([]);
    const getShowTreeData = async () => {
      const params = {
        isNeedMainDep: 1,
        isNeedPerm: 0,
        condition: ''
      };
      try {
        const {
          records,
          code
        } = await getOrgListFetch(params);
        if (code === '0000') {
          treeData.value = records;
        }
      } catch (e) {}
    };
    expose({
      searchData
    });
    onMounted(() => {
      getShowTreeData();
    });
    return (_ctx, _cache) => {
      var _unref2, _unref3;
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_table = _resolveComponent("a-table");
      const _directive_permission = _resolveDirective("permission");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives((_openBlock(), _createBlock(_component_a_button, {
        class: "add-btn",
        type: "primary",
        onClick: toAddNotification
      }, {
        icon: _withCtx(() => [_createVNode(_component_svg_icon, {
          "icon-class": "add",
          class: "add-icon"
        })]),
        default: _withCtx(() => [_createTextVNode(" 发布通知 ")]),
        _: 1
      })), [[_directive_permission, {
        permissionValue: 'goodsJudge',
        permissionArr: (_unref2 = _unref(userInfo)) === null || _unref2 === void 0 ? void 0 : _unref2.permissions
      }]]), _withDirectives((_openBlock(), _createBlock(_component_a_button, {
        danger: "",
        class: "add-btn",
        onClick: batchDetel
      }, {
        default: _withCtx(() => [_createTextVNode(" 批量删除 ")]),
        _: 1
      })), [[_directive_permission, {
        permissionValue: 'goodsJudge',
        permissionArr: (_unref3 = _unref(userInfo)) === null || _unref3 === void 0 ? void 0 : _unref3.permissions
      }]])])]), _createVNode(_component_a_table, {
        bordered: "",
        columns: columns,
        height: 300,
        "data-source": dataSource.value,
        "row-key": "id",
        ref_key: "tableRef",
        ref: tableRef,
        "row-selection": {
          selectedRowKeys: selectedRowKeys.value,
          onChange: onSelectChange,
          preserveSelectedRowKeys: true
          // renderCell:(checked, record, index, originNode) => {
          //   if (record?.sendStatus == 1) {
          //     return null;
          //   }
          //   return originNode;
          // },
        },
        pagination: {
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '30', '40'],
          showTotal: total => `共${total}条`
        },
        loading: tableLoading.value
      }, {
        bodyCell: _withCtx(({
          column,
          record
        }) => {
          var _unref$find;
          return [column.dataIndex === 'handle' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_a_button, {
            type: "link",
            onClick: $event => LookListItem(record.id)
          }, {
            default: _withCtx(() => [_createTextVNode("查看")]),
            _: 2
          }, 1032, ["onClick"]), record.sendStatus == 1 ? (_openBlock(), _createBlock(_component_a_button, {
            key: 0,
            type: "link",
            onClick: $event => GoBackItem(record.id)
          }, {
            default: _withCtx(() => [_createTextVNode("取回")]),
            _: 2
          }, 1032, ["onClick"])) : (_openBlock(), _createBlock(_component_a_button, {
            key: 1,
            type: "link",
            onClick: $event => DelListItem(record.id)
          }, {
            default: _withCtx(() => [_createTextVNode("删除")]),
            _: 2
          }, 1032, ["onClick"]))])) : _createCommentVNode("", true), column.dataIndex === 'sendUserNum' ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString((record === null || record === void 0 ? void 0 : record.receivedUserNum) || 0) + "/" + _toDisplayString(record === null || record === void 0 ? void 0 : record.sendUserNum), 1)) : _createCommentVNode("", true), column.dataIndex === 'sendStatus' ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString((_unref$find = _unref(statusList).find(item1 => item1.value == (record === null || record === void 0 ? void 0 : record.sendStatus))) === null || _unref$find === void 0 ? void 0 : _unref$find.label), 1)) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["data-source", "row-selection", "pagination", "loading"])]);
    };
  }
});